import styled from "styled-components";

const DialogContentText = styled.p`
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin: 0;
`;

export default DialogContentText;


// WEBPACK FOOTER //
// ./src/SharedComponents/Dialog/DialogContentText.tsx